'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _slice = Array.prototype.slice;

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _sharedTypeUtils = require('../shared/type-utils');

var _utilsClone = require('../utils/clone');

var _utilsClone2 = _interopRequireDefault(_utilsClone);

var _utilsBaseValidator = require('../utils/base-validator');

var _errors = require('../errors');

var _ref = require('../ref');

/**
 * @class WixDataFilter
 * @description Provides functionality for filtering a query.
 * @memberof wix-data
 */
var filterMixin = function filterMixin() {
  var Base = arguments.length <= 0 || arguments[0] === undefined ? (function () {
    function _class() {
      _classCallCheck(this, _class);
    }

    return _class;
  })() : arguments[0];
  return (function (_Base) {
    _inherits(_class2, _Base);

    function _class2() {
      var obj = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

      _classCallCheck(this, _class2);

      _get(Object.getPrototypeOf(_class2.prototype), 'constructor', this).call(this, obj);
      this.filterTree = obj.filterTree || { '$and': [] };
      this.invalidArguments = obj.invalidArguments || [];
    }

    /**
     * @function eq
     * @syntax
     * function eq(propertyName: string, value: *): WixDataQuery
     * @summary Refines a query or filter to match items whose specified property value equals the specified value.
     * @param {external:String} propertyName The property whose value will be compared with `value`.
     * @param {} value The value to match against.
     * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
     * @description
     *  The `eq()` function refines a `WixDataQuery` or `WixDataFilter` to only
     *  match items where the value of the specified property equals the specified `value`.
     *
     *  It only matches values of the same type. For example, a number value stored
     *  as a String type does not match the same number stored as a Number type.
     *
     *  If the value of the `propertyName` property is an Array, `eq()` includes items
     *  in which any of the elements of the Array match the specified `value`.
     * @snippet [FilterMixin-eq.es6=Add an equals filter to a query]
     * @snippet [FilterMixin-eq_scenario.es6=Create a query, add an equals filter, and run it]
     * @snippet [FilterMixin-eq_scenario_plus.es6=Create a query, add an equals filter, and run it]
     * @memberof wix-data.WixDataFilter
     * @instance
     */

    _createClass(_class2, [{
      key: 'eq',
      value: function eq(field, value) {
        return this._binaryAnd('$eq', '.eq', arguments);
      }

      /**
       * @function ne
       * @syntax
       * function ne(propertyName: string, value: *): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property value does not equal the specified value.
       * @param {external:String} propertyName The property whose value will be compared with `value`.
       * @param {} value The value to match against.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `ne()` function refines a `WixDataQuery` or `WixDataFilter` to only
       *  match items where the value of the specified property does not equal the specified `value`.
       *
       *  It only matches values of the same type. For example, a number value stored
       *  as a String type is considered not equal to the same number stored as a Number type.
       *
       *  If the value of the `propertyName` property is an Array, `ne()` includes items
       *  in which none of the elements of the Array match the specified `value`.
       * @snippet [FilterMixin-ne.es6=Add a not equals filter to a query]
       * @snippet [FilterMixin-ne_scenario.es6=Create a query, add a not equals filter, and run it]
       * @snippet [FilterMixin-ne_scenario_plus.es6=Create a query, add a not equals filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'ne',
      value: function ne(field, value) {
        return this._binaryAnd('$ne', '.ne', arguments);
      }

      /**
       * @function ge
       * @syntax
       * function ge(propertyName: string, value: string|number|date): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property value is greater than or equal to the specified value.
       * @param {external:String} propertyName The property whose value will be compared with `value`.
       * @param {external:String|external:Number|external:Date} value The value to match against.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `ge()` function refines a `WixDataQuery` or `WixDataFilter` to only
       *  match items where the value of the specified property is greater than or
       *  equal to the specified `value`.
       *
       *  It only matches values of the same type. For example, a number value stored
       *  as a String type does not match the same number stored as a Number type.
       *
       *  If a property contains a number as a String, that value will be compared
       *  alphabetically and not numerically. Items that do not have a value for the
       *  specified property are ranked lowest.
       *
       *  The following types of properties can be compared:
       *
       *  + Number: Compares numerically.
       *  + Date: Compares JavaScript Date objects.
       *  + String: Compares alphabetically. The sort is based on the JavaScript sort methodology, which is a lexicographical sort that compares Unicode characters by their code points.
       *  + Reference: Compares by the ID of the referenced item as a String.
       *
       *
       * @snippet [FilterMixin-ge.es6=Add a greater than or equals filter to a query]
       * @snippet [FilterMixin-ge_scenario.es6=Create a query, add a greater than or equals filter, and run it]
       * @snippet [FilterMixin-ge_scenario_plus.es6=Create a query, add a greater than or equals filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'ge',
      value: function ge(field, value) {
        return this._AndLogicalEquivalence('$gte', '.ge', arguments);
      }

      /**
       * @function gt
       * @syntax
       * function gt(propertyName: string, value: string|number|date): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property value is greater than the specified value.
       * @param {external:String} propertyName The property whose value will be compared with `value`.
       * @param {external:String|external:Number|external:Date} value The value to match against.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object with the query definition, based on the supplied parameters.
       * @description
       *  The `gt()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the value
       *  of the specified property is greater than the specified `value`.
       *
       *  It only matches values of the same type. For example, a number value stored
       *  as a String type does not match the same number stored as a Number type.
       *
       *  If a property contains a number as a String, that value will be compared
       *  alphabetically and not numerically. Items that do not have a value for the
       *  specified property are ranked lowest.
       *
       *  The following types of properties can be compared:
       *
       *  + Number: Compares numerically.
       *  + Date: Compares JavaScript Date objects.
       *  + String: Compares alphabetically. The sort is based on the JavaScript sort methodology, which is a lexicographical sort that compares Unicode characters by their code points.
       *  + Reference: Compares by the ID of the referenced item as a String.
       *
       *
       * @snippet [FilterMixin-gt.es6=Add a greater than filter to a query]
       * @snippet [FilterMixin-gt_scenario.es6=Create a query, add a greater than filter, and run it]
       * @snippet [FilterMixin-gt_scenario_plus.es6=Create a query, add a greater than filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'gt',
      value: function gt(field, value) {
        return this._AndLogicalEquivalence('$gt', '.gt', arguments);
      }

      /**
      * @function le
      * @syntax
      * function le(propertyName: string, value: string|number|date): WixDataQuery
      * @summary Refines a query or filter to match items whose specified property value is less than or equal to the specified value.
      * @param {external:String} propertyName The property whose value will be compared with `value`.
      * @param {external:String|external:Number|external:Date} value The value to match against.
      * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
      * @description
      *  The `le()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the value
      *  of the specified property is less than or equal to the specified `value`.
      *
      *  It only matches values of the same type. For example, a number value stored
      *  as a String type does not match the same number stored as a Number type.
      *
      *  If a property contains a number as a String, that value will be compared
      *  alphabetically and not numerically. Items that do not have a value for the
      *  specified property are ranked lowest.
      *
      *  The following types of properties can be compared:
      *
      *  + Number: Compares numerically.
      *  + Date: Compares JavaScript Date objects.
      *  + String: Compares alphabetically. The sort is based on the JavaScript sort methodology, which is a lexicographical sort that compares Unicode characters by their code points.
      *  + Reference: Compares by the ID of the referenced item as a String.
      *
      *
      * @snippet [FilterMixin-le.es6=Add a less than or equals filter to a query]
      * @snippet [FilterMixin-le_scenario.es6=Create a query, add a less than or equals filter, and run it]
      * @snippet [FilterMixin-le_scenario_plus.es6=Create a query, add a less than or equals filter, and run it]
      * @memberof wix-data.WixDataFilter
      * @instance
       */
    }, {
      key: 'le',
      value: function le(field, value) {
        return this._AndLogicalEquivalence('$lte', '.le', arguments);
      }

      /**
      * @function lt
      * @syntax
      * function lt(propertyName: string, value: string|number|date): WixDataQuery
      * @summary Refines a query or filter to match items whose specified property value is less than the specified value.
      * @param {external:String} propertyName The property whose value will be compared with `value`.
      * @param {external:String|external:Number|external:Date} value The value to match against.
      * @returns {wix-data.WixDataQuery} A `WixDataQuery` object with the query definition, based on the supplied parameters.
      * @description
      *  The `lt()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the value
      *  of the specified property is less than the specified `value`.
      *
      *  It only matches values of the same type. For example, a number value stored
      *  as a String type does not match the same number stored as a Number type.
      *
      *  If a property contains a number as a String, that value will be compared
      *  alphabetically and not numerically. Items that do not have a value for the
      *  specified property are ranked lowest.
      *
      *  The following types of properties can be compared:
      *
      *  + Number: Compares numerically.
      *  + Date: Compares JavaScript Date objects.
      *  + String: Compares alphabetically. The sort is based on the JavaScript sort methodology, which is a lexicographical sort that compares Unicode characters by their code points.
      *  + Reference: Compares by the ID of the referenced item as a String.
      *
      *
      * @snippet [FilterMixin-lt.es6=Add a less than filter to a query]
      * @snippet [FilterMixin-lt_scenario.es6=Create a query, add a less than filter, and run it]
      * @snippet [FilterMixin-lt_scenario_plus.es6=Create a query, add a less than filter, and run it]
      * @memberof wix-data.WixDataFilter
      * @instance
       */
    }, {
      key: 'lt',
      value: function lt(field, value) {
        return this._AndLogicalEquivalence('$lt', '.lt', arguments);
      }

      /**
       * @function isNotEmpty
       * @syntax
       * function isNotEmpty(propertyName: string): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property has any value.
       * @param {external:String} propertyName The property in which to check for a value.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `isNotEmpty()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the
       *  value of the specified property is not `null` or `undefined`.
       *
       *  If the property contains any value at all for a given item, including the
       *  empty string or an invalid value, that item will match the query.
       * @snippet [FilterMixin-isNotEmpty.es6=Add an isNotEmpty filter to a query]
       * @snippet [FilterMixin-isNotEmpty_scenario.es6=Create a query, add an isNotEmpty filter, and run it]
       * @snippet [FilterMixin-isNotEmpty_scenario_plus.es6=Create a query, add an isNotEmpty filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'isNotEmpty',
      value: function isNotEmpty(field) {
        var _filterValidator$arityIsOne$validFieldName$validateAndAggregate = this._filterValidator('.isNotEmpty').arityIsOne(arguments).validFieldName(field).validateAndAggregate(this.invalidArguments);

        var _filterValidator$arityIsOne$validFieldName$validateAndAggregate2 = _slicedToArray(_filterValidator$arityIsOne$validFieldName$validateAndAggregate, 2);

        var newInvalidArguments = _filterValidator$arityIsOne$validFieldName$validateAndAggregate2[0];
        var valid = _filterValidator$arityIsOne$validFieldName$validateAndAggregate2[1];

        if (valid) {
          return this.ne(field, null);
        }

        return this._copy(this.filterTree, newInvalidArguments);
      }

      /**
       * @function isEmpty
       * @syntax
       * function isEmpty(propertyName: string): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property does not exist or does not have any value.
       * @param {external:String} propertyName The the property in which to check for a value.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `isEmpty()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the
       *  value of the specified property is `null` or `undefined` or the property does
       *  not exist.
       *
       *  If the property contains any value at all for a given item, including the
       *  empty string or an invalid value, that item will match the query.
       * @snippet [FilterMixin-isEmpty.es6=Add an isEmpty filter to a query]
       * @snippet [FilterMixin-isEmpty_scenario.es6=Create a query, add an isEmpty filter, and run it]
       * @snippet [FilterMixin-isEmpty_scenario_plus.es6=Create a query, add an isEmpty filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'isEmpty',
      value: function isEmpty(field) {
        var _filterValidator$arityIsOne$validFieldName$validateAndAggregate3 = this._filterValidator('.isEmpty').arityIsOne(arguments).validFieldName(field).validateAndAggregate();

        var _filterValidator$arityIsOne$validFieldName$validateAndAggregate32 = _slicedToArray(_filterValidator$arityIsOne$validFieldName$validateAndAggregate3, 2);

        var newInvalidArguments = _filterValidator$arityIsOne$validFieldName$validateAndAggregate32[0];
        var valid = _filterValidator$arityIsOne$validFieldName$validateAndAggregate32[1];

        if (valid) {
          return this.eq(field, null);
        }

        return this._copy(this.filterTree, newInvalidArguments);
      }

      /**
       * @function startsWith
       * @syntax
       * function startsWith(propertyName: string, string: string): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property value starts with a specified string.
       * @param {external:String} propertyName The property whose value will be compared with the string.
       * @param {external:String} string  The string to look for at the beginning of the specified property value.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `startsWith()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the value
       *  of the specified property starts with the defined `string`.
       *
       *  You can only use `startsWith()` with a property whose value is a String or Reference.
       *  When using a Reference, `startsWith()` matches by the ID of the referenced item as Strings.
       *
       * @snippet [FilterMixin-startsWith.es6=Add a starts with filter to a query]
       * @snippet [FilterMixin-startsWith_scenario.es6=Create a query, add a starts with filter, and run it]
       * @snippet [FilterMixin-startsWith_scenario_plus.es6=Create a query, add a starts with filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'startsWith',
      value: function startsWith(field, value) {
        return this._AndStringOperand('$startsWith', '.startsWith', arguments);
      }

      /**
        * @function endsWith
        * @syntax
        * function endsWith(propertyName: string, string: string): WixDataQuery
        * @summary Refines a query or filter to match items whose specified property value ends with a specified string.
        * @param {external:String} propertyName The property whose value will be compared with the string.
        * @param {external:String} string  The string to look for at the beginning of the specified property value.
        * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
        * @description
        *  The `endsWith()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the value
        *  of the specified property ends with the specified `string`.
        *
        *  You can only use `endsWith()` with a property whose value is a String or Reference.
        *  When using a Reference, `endsWith()` matches by the ID of the referenced item as Strings.
        *
        * @snippet [FilterMixin-endsWith.es6=Add an ends with filter to a query]
        * @snippet [FilterMixin-endsWith_scenario.es6=Create a query, add an ends with filter, and run it]
        * @snippet [FilterMixin-endsWith_scenario_plus.es6=Create a query, add an ends with filter, and run it]
        * @memberof wix-data.WixDataFilter
        * @instance
        */
    }, {
      key: 'endsWith',
      value: function endsWith(field, value) {
        return this._AndStringOperand('$endsWith', '.endsWith', arguments);
      }

      /**
        * @function contains
        * @syntax
        * function contains(propertyName: string, string: string): WixDataQuery
        * @summary Refines a query or filter to match items whose specified property value contains a specified string.
        * @param {external:String} propertyName The property whose value will be compared with the string.
        * @param {external:String} string  The string to look for inside the specified property value.
        * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
        * @description
        *  The `contains()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the value
        *  of the specified property contains the specified `string`.
        *
        *  You can only use `contains()` with a property whose value is a String or Reference.
        *  When using a Reference, `contains()` matches by the ID of the referenced item as Strings.
        *
        * @snippet [FilterMixin-contains.es6=Add a contains filter to a query]
        * @snippet [FilterMixin-contains_scenario.es6=Create a query, add a contains filter, and run it]
        * @snippet [FilterMixin-contains_scenario_plus.es6=Create a query, add a contains filter, and run it]
        * @memberof wix-data.WixDataFilter
        * @instance
        */
    }, {
      key: 'contains',
      value: function contains(field, value) {
        return this._AndStringOperand('$contains', '.contains', arguments);
      }

      /**
       * @function hasSome
       * @syntax
       * function hasSome(propertyName: string, ...value: *): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property value equals any of the specified `value` parameters.
       * @param {external:String} propertyName The property whose value will be compared with `value`.
       * @param {...external:String|external:Number|external:Date|external:Array} value The values to match against.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `hasSome()` function refines a `WixDataQuery` or `WixDataFilter` to
       *  only match items where the value of the specified property equals any of
       *  the specified values.
       *
       *  If the value of the specified property is an array, `hasSome()` will match
       *  if any of the elements of that array match any of the specified values.
       *
       *  If the specified property contains multiple references, pass item IDs in the
       *  `value` property. In such a case, `hasSome()` will match if any of the
       *  multiple references match any of the specified ID values.
       *
       *  You can specify a list of values to match by providing comma-separated
       *  String, Number, or Date types as the `value` parameters. You can also
       *  specify a list of these values by including them in an array and providing
       *  the array as the `value`.
       *
       * @snippet [FilterMixin-hasSome.es6=Add a has some filter to a query]
       * @snippet [FilterMixin-hasSome_scenario.es6=Create a query, add a has some filter, and run it]
       * @snippet [FilterMixin-hasSome_scenario_plus.es6=Create a query, add a has some filter, and run it]
       * @snippet [FilterMixin-hasSome_multiref.es6=Add a has some filter on a multiple reference field to a query]
       *  This example gets the items from the **movies** collection that have a
       *  reference in the **authors** field to an item with an ID that is either
       *  **1357** or **2468**.
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'hasSome',
      value: function hasSome(field, values) {
        return this._AndSetOperand('$hasSome', '.hasSome', arguments);
      }

      /**
       * @function hasAll
       * @syntax
       * function hasAll(propertyName: string, ...value: *): WixDataQuery
       * @summary Refines a query or filter to match items whose specified property values equals all of the specified `value` parameters.
       * @param {external:String} propertyName The property whose value will be compared with `value`.
       * @param {...external:String|external:Number|external:Date|external:Array} value The values to match against.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `hasAll()` function refines a `WixDataQuery` or `WixDataFilter` to
       *  only match items where the value of the specified property equals all of
       *  the specified values.
       *
       *  If the value of the specified property is an array, `hasAll()` will match
       *  if there is a match in the elements of that array for all of the specified
       *  values.
       *
       *  You can specify a list of values to match by providing comma-separated
       *  String, Number, or Date types as the `value` parameters. You can also
       *  specify a list of these values by including them in an array and providing
       *  the array as the `value`.
       * @snippet [FilterMixin-hasAll.es6=Add a has all filter to a query]
       * @snippet [FilterMixin-hasAll_scenario.es6=Create a query, add a has all filter, and run it]
       * @snippet [FilterMixin-hasAll_scenario_plus.es6=Create a query, add a has all filter, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'hasAll',
      value: function hasAll(field, values) {
        return this._AndSetOperand('$hasAll', '.hasAll', arguments);
      }

      /*eslint no-unused-vars: 0*/

      /**
       * @function or
       * @syntax
       * function or(query: WixDataQuery): WixDataQuery
       * @summary Adds an `or` condition to the query or filter.
       * @param {wix-data.WixDataQuery} query A query to add to the initial query as an `or` condition.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `or()` function adds an inclusive `or` condition to a `WixDataQuery` or `WixDataFilter`. A query or filter
       *  with an `or` returns all the items that match the query or filter as defined up to
       *  the `or` function, the items that match the query or filter passed to the `or`
       *  function, and the items that match both.
       *
       *  The collections used by both the initial query and the query passed
       *  to the `or` function must be the same.
       *
       *  If the query or filter only contains an `or()` function, it returns all the items in the collection.
       * @snippet [FilterMixin-or.es6=Add an or to a query]
       * @snippet [FilterMixin-or_scenario.es6=Create a query, add an or, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'or',
      value: function or(otherQuery) {
        var _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate = this._filterValidator('.or').arityIsOne(arguments).isInstanceOfSameClass(otherQuery).isForCollection(otherQuery, this.collectionName).validateAndAggregate();

        var _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate2 = _slicedToArray(_filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate, 2);

        var newInvalidArguments = _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate2[0];
        var valid = _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate2[1];

        if (valid) {
          return this._copy(inAnd({ '$or': [this.filterTree, otherQuery.filterTree] }), newInvalidArguments.concat(otherQuery.invalidArguments));
        } else {
          return this._copy(this.filterTree, newInvalidArguments);
        }
      }

      /**
       * @function and
       * @syntax
       * function and(query: WixDataQuery): WixDataQuery
       * @summary Adds an `and` condition to the query or filter.
       * @param {wix-data.WixDataQuery} query A query to add to the initial query as an `and` condition.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `and()` function adds an `and` condition to a `WixDataQuery` or `WixDataFilter`.
       *  A query or filter with an `and` returns all the items that match the query
       *  or filter as defined up to the `and` function and also match the query or
       *  filter passed to the `and` function.
       *
       *  Note that when chaining multiple `WixDataFilter` functions to a query an `add` condition is assumed.
       *  In such cases, you do not need to add a call to the `and()` function.
       *  For example, this query returns results where status is active **and** age is
       *  greater than 25.
       *
       *  ```javascript
       *  wixData.query("myCollection")
       *    .eq("status", "active")
       *    .gt("age", 25);
       *  ```
       *
       *  The `and()` function, is needed when perfoming compound queries. For
       *  example, the final query in this set of queries returns results where status
       *  is either pending or rejected **and** age is either less than 25 or greater than 65.
       *
       *  ```javascript
       *  let statusQuery = wixData.query("myCollection")
       *    .eq("status", "pending")
       *    .or(
       *      wixData.query("myCollection")
       *        .eq("status", "rejected")
       *    );
       *
       *  let ageQuery = wixData.query("myCollection")
       *    .lt("age", 25)
       *    .or(
       *      wixData.query("myCollection")
       *        .gt("age", 65)
       *    );
       *
       *  let statusAndAgeQuery = statusQuery.and(ageQuery);
       *  ```
       *
       *  The collections referenced by both the initial query and the query passed
       *  to the `and` function must be the same.
       *
       *  If the query or filter only contains an `and()` function, it returns all the items in the collection.
       * @snippet [FilterMixin-and.es6=Add an and to a query]
       * @snippet [FilterMixin-and_scenario.es6=Create a query, add an or, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */
    }, {
      key: 'and',
      value: function and(otherQuery) {
        var _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate3 = this._filterValidator('.and').arityIsOne(arguments).isInstanceOfSameClass(otherQuery).isForCollection(otherQuery, this.collectionName).validateAndAggregate();

        var _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate32 = _slicedToArray(_filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate3, 2);

        var newInvalidArguments = _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate32[0];
        var valid = _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate32[1];

        if (valid) {
          return this._copy(inAnd(this.filterTree, otherQuery.filterTree), newInvalidArguments.concat(otherQuery.invalidArguments));
        } else {
          return this._copy(this.filterTree, newInvalidArguments);
        }
      }

      /**
       * @function not
       * @syntax
       * function not(query: WixDataQuery): WixDataQuery
       * @summary Adds a `not` condition to the query or filter.
       * @param {wix-data.WixDataQuery} query A query to add to the initial query as a `not` condition.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `not()` function adds a `not` condition to a `WixDataQuery` or `WixDataFilter`. A query or filter with a `not`
       *  returns all the items that match the query or filter as defined up to the `not`
       *  function, but don't match the query or filter passed to the `not` function.
       *
       *  If the query or filter only contains a `not()` function, it returns all the items
       *  that don't match the query defined by the `not` method.
       *
       *  The collections referenced by both the initial query and the query passed
       *  to the `not` function must be the same.
       * @snippet [FilterMixin-not.es6=Add a not to a query]
       * @snippet [FilterMixin-not_scenario.es6=Create a query, add a not, and run it]
       * @memberof wix-data.WixDataFilter
       * @instance
       */

    }, {
      key: 'not',
      value: function not(otherQuery) {
        var _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate4 = this._filterValidator('.not').arityIsOne(arguments).isInstanceOfSameClass(otherQuery).isForCollection(otherQuery, this.collectionName).validateAndAggregate();

        var _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate42 = _slicedToArray(_filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate4, 2);

        var newInvalidArguments = _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate42[0];
        var valid = _filterValidator$arityIsOne$isInstanceOfSameClass$isForCollection$validateAndAggregate42[1];

        if (valid) {
          var newFilterTree = (0, _utilsClone2['default'])(this.filterTree);
          var notClause = { '$not': [otherQuery.filterTree] };
          var resultingFilter = inAndOptimized(newFilterTree, notClause);

          return this._copy(resultingFilter, newInvalidArguments.concat(otherQuery.invalidArguments));
        } else {
          return this._copy(this.filterTree, newInvalidArguments);
        }
      }

      /**
      * @function between
      * @syntax
      * function between(propertyName: string, rangeStart: string|number|date,
      *   rangeEnd: string|number|date): WixDataQuery
      * @summary Refines a query or filter to match items whose specified property value is within a specified range.
      * @param {external:String} propertyName The property whose value will be compared with `rangeStart` and `rangeEnd`.
      * @param {external:String|external:Number|external:Date} rangeStart The beginning value of the range to match against.
      * @param {external:String|external:Number|external:Date} rangeEnd The ending value of the range to match against.
      * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
      * @description
      *  The `between()` function refines a `WixDataQuery` or `WixDataFilter` to only match items where the value
      *  of the specified property is greater than or equal to `rangeStart` and less
      *  than or equal to `rangeEnd`.
      *
      *  It only matches values of the same type. For example, a number value stored
      *  as a String type does not match the same number stored as a Number type.
      *
      *  If a property contains a number as a String, that value will be compared
      *  alphabetically and not numerically. Items that do not have a value for the
      *  specified property are ranked lowest.
      *
      *  The following types of properties can be compared:
      *
      *  + Number: Compares numerically.
      *  + Date: Compares JavaScript Date objects.
      *  + String: Compares alphabetically. The sort is based on the JavaScript sort methodology, which is a lexicographical sort that compares Unicode characters by their code points.
      *
      *
      * @snippet [FilterMixin-between.es6=Add a between filter to a query]
      * @snippet [FilterMixin-between_scenario.es6=Create a query, add a between filter, and run it]
      * @snippet [FilterMixin-between_scenario_plus.es6=Create a query, add a between filter, and run it]
      * @memberof wix-data.WixDataFilter
      * @instance
       */

    }, {
      key: 'between',
      value: function between(field, rangeStart, rangeEnd) {
        var _filterValidator$arityIsThree$sameType$typeIsStringNumberOrDate$typeIsStringNumberOrDate$validateAndAggregate = this._filterValidator('.between').arityIsThree(arguments).sameType(rangeStart, rangeEnd).typeIsStringNumberOrDate(rangeStart).typeIsStringNumberOrDate(rangeEnd).validateAndAggregate();

        var _filterValidator$arityIsThree$sameType$typeIsStringNumberOrDate$typeIsStringNumberOrDate$validateAndAggregate2 = _slicedToArray(_filterValidator$arityIsThree$sameType$typeIsStringNumberOrDate$typeIsStringNumberOrDate$validateAndAggregate, 2);

        var newInvalidArguments = _filterValidator$arityIsThree$sameType$typeIsStringNumberOrDate$typeIsStringNumberOrDate$validateAndAggregate2[0];
        var valid = _filterValidator$arityIsThree$sameType$typeIsStringNumberOrDate$typeIsStringNumberOrDate$validateAndAggregate2[1];

        if (valid) {
          return this.ge(field, rangeStart).lt(field, rangeEnd);
        }

        return this._copy(this.filterTree, newInvalidArguments);
      }

      // used only from data binding router internally
    }, {
      key: '_matchesUrlized',
      value: function _matchesUrlized(field, operand) {
        var _filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate = this._filterValidator('._matchesUrlized').arityIsTwo(arguments).validFieldName(field).typeIsString(operand).validateAndAggregate();

        var _filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate2 = _slicedToArray(_filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate, 2);

        var newInvalidArguments = _filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate2[0];
        var valid = _filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate2[1];

        if (valid) {
          var newFilterTree = this._makeNewFilter.apply(this, [field].concat(_toConsumableArray(createMatchesOrInFilter(operand))));
          return this._copy(newFilterTree, newInvalidArguments);
        }

        return this._copy(this.filterTree, newInvalidArguments);
      }
    }, {
      key: '_binaryAnd',
      value: function _binaryAnd(filterOperatorSymbol, operatorName, args) {
        var _Array$prototype$slice$call = Array.prototype.slice.call(args);

        var _Array$prototype$slice$call2 = _slicedToArray(_Array$prototype$slice$call, 2);

        var field = _Array$prototype$slice$call2[0];
        var operand = _Array$prototype$slice$call2[1];

        var _filterValidator$arityIsTwo$validFieldName$validateAndAggregate = this._filterValidator(operatorName).arityIsTwo(args).validFieldName(field).validateAndAggregate();

        var _filterValidator$arityIsTwo$validFieldName$validateAndAggregate2 = _slicedToArray(_filterValidator$arityIsTwo$validFieldName$validateAndAggregate, 1);

        var newInvalidArguments = _filterValidator$arityIsTwo$validFieldName$validateAndAggregate2[0];

        var newFilterTree = this._makeNewFilter(field, filterOperatorSymbol, operand);

        return this._copy(newFilterTree, newInvalidArguments);
      }
    }, {
      key: '_AndLogicalEquivalence',
      value: function _AndLogicalEquivalence(filterOperatorSymbol, operatorName, args) {
        var _Array$prototype$slice$call3 = Array.prototype.slice.call(args);

        var _Array$prototype$slice$call32 = _slicedToArray(_Array$prototype$slice$call3, 2);

        var field = _Array$prototype$slice$call32[0];
        var operand = _Array$prototype$slice$call32[1];

        var _filterValidator$arityIsTwo$validFieldName$typeIsStringNumberOrDate$validateAndAggregate = this._filterValidator(operatorName).arityIsTwo(args).validFieldName(field).typeIsStringNumberOrDate(operand).validateAndAggregate();

        var _filterValidator$arityIsTwo$validFieldName$typeIsStringNumberOrDate$validateAndAggregate2 = _slicedToArray(_filterValidator$arityIsTwo$validFieldName$typeIsStringNumberOrDate$validateAndAggregate, 1);

        var newInvalidArguments = _filterValidator$arityIsTwo$validFieldName$typeIsStringNumberOrDate$validateAndAggregate2[0];

        var newFilterTree = this._makeNewFilter(field, filterOperatorSymbol, operand);
        return this._copy(newFilterTree, newInvalidArguments);
      }
    }, {
      key: '_AndStringOperand',
      value: function _AndStringOperand(filterOperatorName, operatorName, args) {
        var _Array$prototype$slice$call4 = Array.prototype.slice.call(args);

        var _Array$prototype$slice$call42 = _slicedToArray(_Array$prototype$slice$call4, 2);

        var field = _Array$prototype$slice$call42[0];
        var operand = _Array$prototype$slice$call42[1];

        var _filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate3 = this._filterValidator(operatorName).arityIsTwo(args).validFieldName(field).typeIsString(operand).validateAndAggregate();

        var _filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate32 = _slicedToArray(_filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate3, 1);

        var newInvalidArguments = _filterValidator$arityIsTwo$validFieldName$typeIsString$validateAndAggregate32[0];

        var newFilterTree = this._makeNewFilter(field, filterOperatorName, operand);

        return this._copy(newFilterTree, newInvalidArguments);
      }
    }, {
      key: '_AndSetOperand',
      value: function _AndSetOperand(filterOperatorName, operatorName, args) {
        var _Array$prototype$slice$call5 = Array.prototype.slice.call(args);

        var _Array$prototype$slice$call52 = _toArray(_Array$prototype$slice$call5);

        var field = _Array$prototype$slice$call52[0];

        var rawOperands = _Array$prototype$slice$call52.slice(1);

        var operands = (0, _sharedTypeUtils.isArray)(rawOperands[0]) ? rawOperands[0] : rawOperands;

        var _filterValidator$arityIsAtLeastTwo$validFieldName$typeIsStringNumberOrDateForAll$validateAndAggregate = this._filterValidator(operatorName).arityIsAtLeastTwo(args).validFieldName(field).typeIsStringNumberOrDateForAll(operands).validateAndAggregate();

        var _filterValidator$arityIsAtLeastTwo$validFieldName$typeIsStringNumberOrDateForAll$validateAndAggregate2 = _slicedToArray(_filterValidator$arityIsAtLeastTwo$validFieldName$typeIsStringNumberOrDateForAll$validateAndAggregate, 1);

        var newInvalidArguments = _filterValidator$arityIsAtLeastTwo$validFieldName$typeIsStringNumberOrDateForAll$validateAndAggregate2[0];

        var newFilterTree = this._makeNewFilter(field, filterOperatorName, operands);
        return this._copy(newFilterTree, newInvalidArguments);
      }
    }, {
      key: '_makeNewFilter',
      value: function _makeNewFilter(field, filterOperatorName, operand) {
        var newFilterTree = (0, _utilsClone2['default'])(this.filterTree);

        var newFilter = this._buildFilter(field, filterOperatorName, operand);

        if ((0, _sharedTypeUtils.isArray)(newFilterTree['$and'])) {
          newFilterTree['$and'].push(newFilter);
          return newFilterTree;
        } else {
          var result = isEmptyObject(newFilterTree) ? inAnd(newFilter) : inAnd(newFilterTree, newFilter);
          return result;
        }
      }
    }, {
      key: '_buildFilter',
      value: function _buildFilter(field, filterOperatorName, operand) {
        if (filterOperatorName !== '$eq') {
          var newFilter = {};
          newFilter[field] = {};
          newFilter[field][filterOperatorName] = this._replaceRefs(operand);
          return newFilter;
        } else {
          var newFilter = {};
          newFilter[field] = this._replaceRefs(operand);
          return newFilter;
        }
      }
    }, {
      key: '_replaceRefs',
      value: function _replaceRefs(operand) {
        var _this = this;

        if (operand instanceof _ref.Ref) {
          return operand.id;
        } else if ((0, _sharedTypeUtils.isArray)(operand)) {
          return operand.map(function (operand) {
            return _this._replaceRefs(operand);
          });
        } else {
          return operand;
        }
      }
    }, {
      key: '_copy',
      value: function _copy(filterTree, invalidArguments) {
        return new this.constructor(Object.assign({}, this, {
          filterTree: filterTree,
          invalidArguments: invalidArguments
        }));
      }
    }, {
      key: '_filterValidator',
      value: function _filterValidator(filterOperatorName) {
        return new FilterValidator(filterOperatorName, this.invalidArguments, this.constructor, this.constructorName);
      }
    }]);

    return _class2;
  })(Base);
};

function createMatchesOrInFilter(operand) {
  if (looksLikeAnInteger(operand)) {
    return ['$in', [operand, Number.parseInt(operand)]];
  } else {
    return ['$matches', {
      ignoreCase: true,
      spec: createMatchSpec(operand)
    }];
  }

  function looksLikeAnInteger(str) {
    return (/^-?[0-9]{1,16}$/.test(str)
    );
  }
}

function createMatchSpec(fieldValue) {
  var literals = fieldValue.split('-');
  var result = [];

  for (var i = 0; i < literals.length - 1; i++) {
    appendLiteralSegment(result, literals[i]);
    appendAnyOfSegment(result);
  }
  appendLiteralSegment(result, literals[literals.length - 1]);

  return result;

  function appendLiteralSegment(result, literalValue) {
    if (literalValue.length !== 0) {
      result.push({ type: 'literal', value: literalValue });
    }
  }

  function appendAnyOfSegment(result) {
    result.push({ type: 'anyOf', value: ' -' });
  }
}

function isConjunctiveFormFilter(filterTree) {
  return (0, _sharedTypeUtils.isArray)(filterTree['$and']);
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function inAnd() {
  return {
    '$and': [].concat(_slice.call(arguments))
  };
}

function inAndOptimized() {
  return {
    '$and': [].concat(_slice.call(arguments)).reduce(function (aggr, val) {
      return isConjunctiveFormFilter(val) ? aggr.concat(val['$and']) : aggr.concat([val]);
    }, [])
  };
}

var FilterValidator = (function (_AggregatingValidator) {
  _inherits(FilterValidator, _AggregatingValidator);

  function FilterValidator(operatorName, previousInvalidArguments, ctor, constructorName) {
    _classCallCheck(this, FilterValidator);

    _get(Object.getPrototypeOf(FilterValidator.prototype), 'constructor', this).call(this, previousInvalidArguments);
    this.operatorName = operatorName;
    this.ctor = ctor;
    this.constructorName = constructorName;
  }

  _createClass(FilterValidator, [{
    key: 'typeIsString',
    value: function typeIsString(value) {
      var _this2 = this;

      return this.addValidation(function () {
        return (0, _sharedTypeUtils.isString)(value);
      }, function () {
        return _errors.messages.filterValidations.typeIsString(_this2.operatorName, value);
      });
    }
  }, {
    key: 'typeIsStringNumberOrDate',
    value: function typeIsStringNumberOrDate(value) {
      var _this3 = this;

      return this.addValidation(function () {
        return isDateStringOrNumber(value);
      }, function () {
        return _errors.messages.filterValidations.typeIsStringNumberOrDate(_this3.operatorName, value);
      });
    }
  }, {
    key: 'sameType',
    value: function sameType(first, second) {
      var _this4 = this;

      return this.addValidation(function () {
        return (0, _sharedTypeUtils.typeForDisplay)(first) === (0, _sharedTypeUtils.typeForDisplay)(second);
      }, function () {
        return _errors.messages.filterValidations.sameType(_this4.operatorName, first, second);
      });
    }
  }, {
    key: 'typeIsStringNumberOrDateForAll',
    value: function typeIsStringNumberOrDateForAll(values) {
      var _this5 = this;

      return this.addValidation(function () {
        return values.every(isDateStringOrNumber);
      }, function () {
        return _errors.messages.filterValidations.typeIsStringNumberOrDateForAll(_this5.operatorName);
      });
    }
  }, {
    key: 'validFieldName',
    value: function validFieldName(field) {
      var _this6 = this;

      return this.addValidation(function () {
        return (0, _sharedTypeUtils.isString)(field);
      }, function () {
        return _errors.messages.filterValidations.validFieldName(_this6.operatorName, field);
      });
    }
  }, {
    key: 'isInstanceOfSameClass',
    value: function isInstanceOfSameClass(obj) {
      var _this7 = this;

      return this.addValidation(function () {
        return obj instanceof _this7.ctor;
      }, function () {
        return _errors.messages.filterValidations.isInstanceOfSameClass(_this7.operatorName, _this7.constructorName, obj);
      });
    }
  }, {
    key: 'isForCollection',
    value: function isForCollection(otherFilterBuilder, expectedCollectionName) {
      var _this8 = this;

      return this.addValidation(function () {
        return otherFilterBuilder.collectionName === expectedCollectionName;
      }, function () {
        return _errors.messages.filterValidations.isForCollection(_this8.operatorName, _this8.constructorName, otherFilterBuilder.collectionName);
      });
    }
  }]);

  return FilterValidator;
})(_utilsBaseValidator.AggregatingValidator);

function isDateStringOrNumber(value) {
  return (0, _sharedTypeUtils.isString)(value) || (0, _sharedTypeUtils.isNumber)(value) || (0, _sharedTypeUtils.isDate)(value);
}

exports['default'] = filterMixin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-core/lib/filter/filterMixin.js
// module id = 66
// module chunks = 0